import React from "react";

export default ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24">
    <title>Play Video Icon</title>
    <g>
      <path
        fill="currentColor"
        d="M22.736 10.063L3.879.308C2.346-.484 0 .284 0 2.244v19.505c0 1.757 2.18 2.817 3.879 1.935l18.857-9.75c1.682-.867 1.687-3.004 0-3.871z"
      />
    </g>
  </svg>
);
